module.exports = __webpack_public_path__ + "img/A57-20190408_02.f6a0c306.jpg";